import { sendContactUsRequestCondTech } from '@/services';
import { mapActions } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';
export default {
    name: 'ContactUs',
    props: {
        isMobile: [Object, Boolean]
    },
    data: () => ({
        formKeys: ['name', 'trandingName', 'email', 'phone'],
        loading: false,
        valid: false,
        validateForm: true,
        textRules: {
            name: '',
            type: 'text',
            required: true,
            valid: true
        },
        emailRules: {
            name: 'E-mail',
            type: 'email',
            required: true,
            valid: true
        },
        form: {
            name: '',
            email: '',
            trandingName: '',
            phone: ''
        },
        reasons: [
            { name: 'Dúvidas gerais', value: 'Dúvidas gerais' },
            { name: 'Interesse em assinatura', value: 'Interesse em assinatura' },
            { name: 'Solicitação de orçamento', value: 'Solicitação de orçamento' },
            { name: 'Suporte técnico - chamado', value: 'Suporte técnico - chamado' },
            { name: 'Outro', value: 'Outro' }
        ]
    }),
    computed: {
        disableBtn() {
            return !this.$v.form.$dirty || !this.$v.form.$error;
        }
    },
    validations: {
        form: {
            name: {
                required
            },
            tradingName: {
                required
            },
            phone: {
                required
            },
            email: {
                required,
                email
            }
        }
    },
    methods: {
        ...mapActions('notification', ['showNotification']),
        goToLandingPageCondoTech() {
            if (this.$route.name === 'CondoTechsEnterpriseContactUs') {
                this.$router.push({ name: 'CondoTechsEnterpriseLandingpage' });
            } else {
                this.$router.push({ name: 'CondoTechsLandingpage' });
            }
        },
        async validate() {
            this.$v.$touch();
            this.valid = !this.valid;
            if (!this.$v.$invalid) {
                await this.sendContactUsRequest();
            }
        },
        async sendContactUsRequest() {
            this.loading = true;
            try {
                const data = {
                    company: this.$route.params.id,
                    email: this.form.email,
                    name: this.form.name,
                    phone: this.form.phone,
                    trading_name: this.form.tradingName
                };
                await sendContactUsRequestCondTech(data);
                this.$gtag.event('Lead Qualificado', {
                    event_category: 'Condotechs'
                });
                this.showNotification({
                    text: 'Seu contato foi registrado com sucesso, em breve nossa equipe entrará em contato com você.',
                    type: 'success'
                });
            } catch (error) {
                console.error(error);
                this.showNotification({ text: 'Aconteceu um erro inesperado', type: 'error' });
            } finally {
                this.loading = false;
            }
        }
    }
};
